import { Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  ACTION_BTN_HOVER_CLR,
  SELECT_EXPORT_PAGES,
  SERVER_URL,
} from "@/Constants/common";
import { serviceRouteConstants } from "@/Constants/routingConstants";
import { TOOLTIPTEXT, toastMessageText } from "@/utilities/CommonText";
import { showErrorToast, showSuccessToast } from "@/utilities/utils";

import { _exportAppLocumInvoice } from "../../../../services/clientexport";
import { apiEncrypt } from "../../../../utilities/keyEncryption";
import ExportButton from "../ActionButtons/ExportButton";
import ActionIcons from "../ActionIcons";

/**
 * A function to handle the download of invoices. It checks if a single invoice is selected, then initiates the download process and sets up an interval to check document focus.
 *
 * @return {void}
 */
const Actions = () => {
  const { session, clientUserAllPermissions } = useSelector(
    (state) => state.session,
  );
  const [downloadLoading, setDownloadLoading] = useState(false);
  const { selectedInvoices, isSelectedAll, clientInvoices } = useSelector(
    (state) => state.clientInvoices,
  );
  const [updateData, setUpdateData] = useState(false);
  useEffect(() => {
    setUpdateData(!updateData);
  }, [isSelectedAll, selectedInvoices]);

  let myInterval;
  /**
   * Check if the document has focus and perform certain actions if it doesn't.
   */
  // const checkDocumentFocus = () => {
  //   if (!document.hasFocus()) {
  //     clearInterval(myInterval);
  //     setDownloadLoading(false);
  //     showSuccessToast(toastMessageText.downloadSuccess);
  //     clearInterval(myInterval);
  //   }
  // };
  /**
   * A function that shows a download message, initiates a success toast, and sets an interval to check document focus.
   */
  const ShowDownloadMessage = () => {
    if (selectedInvoices.length == 1) {
      showSuccessToast(toastMessageText.downloadInvoiceOnGoing);
    }
    // myInterval = setInterval(checkDocumentFocus, 1000);
  };
  const getLink = () => {
    let link = "#";

    if (
      selectedInvoices.length == 0 ||
      (selectedInvoices.length > 16 && isSelectedAll == false)
    ) {
      return link;
    }
    link = `${SERVER_URL}${serviceRouteConstants.exportInvoices}?user_id=${apiEncrypt(session.user_id)}&type=${apiEncrypt(session.user_type)}&login_user_token=${session.user_token}&invoice_id=${selectedInvoices.join(",")}&isSelectedAll=${isSelectedAll & 1}&url=${window.location.href}`;
    return link;
  };

  return (
    <div className="Actions_Wrapper tour-applocum-invoice-action">
      {!clientUserAllPermissions ||
      clientUserAllPermissions.is_allow_to_export_invoice !== 0 ? (
        <>
          <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
            <ExportButton
              page={SELECT_EXPORT_PAGES.APPPLOCUM_INVOICE}
              // exportUrl={routingConstants.exportWorked}
              exportFunction={_exportAppLocumInvoice}
              updateData={updateData}
              selectedTablesData={selectedInvoices}
              ignoreIds={
                isSelectedAll
                  ? clientInvoices
                      .filter(
                        (ele) => !selectedInvoices.includes(ele.invoice_id),
                      )
                      .map((ele) => ele.invoice_id)
                      .join(", ")
                  : ""
              }
              isSelectedAll={isSelectedAll}
              extraObj={{
                invoice_id: selectedInvoices.join(","),
              }}
              emptyExportMessage={
                toastMessageText.emptyExportMessageForContract
              }
            />
            <Tooltip title={TOOLTIPTEXT.invoiceDownload}>
              <a
                className={`transition-linear group inline-block ${ACTION_BTN_HOVER_CLR.lightBlue} ${downloadLoading ? "pointer-events-none" : ""}`}
                href={getLink()}
                onClick={(e) => {
                  if (selectedInvoices.length == 0) {
                    e.preventDefault();
                    showErrorToast(toastMessageText.selectInvoiceToDownload, {
                      id: "no-invoice-selected",
                    });
                    return;
                  }
                  if (selectedInvoices.length > 16 || isSelectedAll == true) {
                    e.preventDefault();
                    showErrorToast(toastMessageText.maxInvoiceDownload, {
                      id: "max-invoice-selected",
                    });
                    return;
                  }
                  // setDownloadLoading(true);
                  ShowDownloadMessage();
                }}
                target="_self"
              >
                <ActionIcons isLoading={downloadLoading} type={"download"} />
              </a>
            </Tooltip>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default Actions;
